import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import { Container, Card, CardBody } from "reactstrap";
import StationCycleTime from "./StationCycleTime";
import LiveStationCycleTime from "./LiveStationCycleTime";
import PartCountByDate from "./PartCountByDate";
import PageGrid from "../../components/GridLayout/PageGrid";
import FieldCustomizerPanel, { useFieldCustomizer, StatCards } from "../../components/FieldCustomizer/FieldCustomizer";
import "../../components/FieldCustomizer/FieldCustomizer.css";

const METRIC_FIELDS = [
  { value:"ORDER GOOD PRODUCTS",  label:"Order Good Products"  },
  { value:"ORDER SCRAP",          label:"Order Scrap"          },
  { value:"ORDER TOTAL PRODUCTS", label:"Order Total Products" },
  { value:"SHIFT GOOD PRODUCTS",  label:"Shift Good Products"  },
  { value:"SHIFT SCRAP PRODUCTS", label:"Shift Scrap Products" },
  { value:"SHIFT TOTAL PRODUCTS", label:"Shift Total Products" },
  { value:"running_time",         label:"Running Time"         },
];

const METRIC_DEFAULT_CARDS = [
  { id:"ord_good",   label:"Order Good",   field:"ORDER GOOD PRODUCTS",  icon:"ri-checkbox-circle-line", color:"text-success", visible:true },
  { id:"ord_scrap",  label:"Order Scrap",  field:"ORDER SCRAP",          icon:"ri-close-circle-line",    color:"text-danger",  visible:true },
  { id:"ord_total",  label:"Order Total",  field:"ORDER TOTAL PRODUCTS", icon:"ri-group-line",           color:"text-primary", visible:true },
  { id:"sft_good",   label:"Shift Good",   field:"SHIFT GOOD PRODUCTS",  icon:"ri-checkbox-circle-line", color:"text-success", visible:true },
  { id:"sft_scrap",  label:"Shift Scrap",  field:"SHIFT SCRAP PRODUCTS", icon:"ri-close-circle-line",    color:"text-danger",  visible:true },
  { id:"sft_total",  label:"Shift Total",  field:"SHIFT TOTAL PRODUCTS", icon:"ri-group-line",           color:"text-primary", visible:true },
];

const AdvancedAnalysis = () => {
  const [loading, setLoading] = useState(true);
  const [data,    setData]    = useState(null);
  const machineId = Number(localStorage.getItem("selectedMachineId")) || 74;

  const metricFC = useFieldCustomizer("advanced_metrics", METRIC_DEFAULT_CARDS, []);

  const fetchShiftData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`https://api.hanoch.in/api/mcc-shift-data/?machine_id=${machineId}`);
      setData(res);
    } catch(e) { console.error("API Error", e); }
    finally    { setLoading(false); }
  };

  useEffect(() => {
    fetchShiftData();
    const id = setInterval(fetchShiftData, 60000);
    return () => clearInterval(id);
  }, [machineId]);

  const metrics        = data?.metrics || {};
  const machine_status = data?.machine_status;
  document.title = "Advanced Analysis";

  // Flatten metrics + other fields for StatCards data object
  const metricData = { ...metrics, running_time: data?.running_time };

  const widgets = [
    {
      id: "status",
      label: "Machine Status",
      icon: "mdi mdi-chip",
      defaultW: 12, defaultH: 3, minH: 2,
      content: (
        <Card className="h-100 mb-0">
          <CardBody className="p-3">
            <div className="d-flex flex-wrap align-items-center gap-3">
              <h5 className="mb-0">Running Time: {data?.running_time}</h5>
              <div style={{padding:"4px 10px",borderRadius:6,border:"1px solid #dee2e6"}}>
                <h5 className="mb-0">Part: {data?.part_name}</h5>
              </div>
              <span className="text-muted" style={{fontSize:13}}>Shift: {data?.shift}</span>
              <div className="ms-auto d-flex align-items-center gap-2">
                <div className="blinking-text">
                  <img width="14" height="14"
                    src={machine_status==="running"?"https://img.icons8.com/ios-filled/50/40C057/filled-circle.png":"https://img.icons8.com/ios-filled/50/FA5252/filled-circle.png"}
                    alt={machine_status}/>
                </div>
                <span style={{fontSize:13,fontWeight:500}}>Machine {machine_status}</span>
              </div>
            </div>
          </CardBody>
        </Card>
      ),
    },
    {
      id: "metrics",
      label: "Production Metrics",
      icon: "mdi mdi-chart-box-outline",
      defaultW: 12, defaultH: 5, minH: 4,
      customizer: (
        <FieldCustomizerPanel
          cards={metricFC.cards}
          columns={[]}
          availableFields={METRIC_FIELDS}
          onCardsChange={metricFC.updateCards}
          onColumnsChange={()=>{}}
          onReset={metricFC.resetFields}
        />
      ),
      content: <StatCards cards={metricFC.cards} data={metricData} />,
    },
    {
      id: "stationcycle",
      label: "Station Cycle Time",
      icon: "mdi mdi-timer-outline",
      defaultW: 12, defaultH: 7, minH: 5,
      content: <StationCycleTime />,
    },
    {
      id: "livestation",
      label: "Live Station Cycle Time",
      icon: "mdi mdi-timer-sand",
      defaultW: 12, defaultH: 7, minH: 5,
      content: <LiveStationCycleTime />,
    },
    {
      id: "partcount",
      label: "Part Count by Date",
      icon: "mdi mdi-counter",
      defaultW: 12, defaultH: 7, minH: 5,
      content: <PartCountByDate />,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Advanced Analysis" />
          <PageGrid pageKey="advanced_analysis" widgets={widgets} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AdvancedAnalysis;
